import { memo } from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ourEmail } from 'root/src/shared/constants/mail';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { RedesignLink } from 'root/src/client/v2/common/components/ui/link';
import { Button } from 'root/src/client/v2/common/components/ui/button';
// Redesign replacement for the legacy `SUCCESS_MODAL_MODULE_ID` shown on `DeliveryRatioTooLow`.
// Informational error: lists the drops the creator has not delivered (links to the redesign drop
// pages) plus the support contact. No retry, so a single "Got it" dismiss.
export const RedesignDeliveryRatioTooLowModal = memo(({ campaigns }) => {
    const modal = useRedesignModal();
    const hasCampaigns = campaigns.length > 0;
    return (<RedesignModalShell className="sm:max-w-md">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-amber/30 bg-neon-amber/10">
					<ReportProblemOutlinedIcon sx={{ fontSize: 24 }} className="text-neon-amber"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Delivery ratio is too low</h2>
				<p className="text-sm text-muted-foreground">You are not able to join this drop yet.</p>
			</div>

			{hasCampaigns && (<div className="w-full">
					<p className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
						You have not delivered {campaigns.length > 1 ? 'these drops' : 'this drop'}
					</p>
					<ul className="flex flex-col gap-2">
						{campaigns.map(campaign => (<li key={campaign.campaignMnemonicId}>
								<RedesignLink href={routeUrls.dropRedesign(campaign.campaignMnemonicId)} onClick={modal.hide} className="flex items-center gap-2 rounded-xl border border-solid border-white/[0.08] bg-white/[0.03] px-3 py-2.5 transition-colors hover:border-white/20">
									<span className="flex-1 truncate text-sm font-medium text-foreground">{campaign.campaignName}</span>
									<OpenInNewIcon sx={{ fontSize: 16 }} className="shrink-0 text-muted-foreground"/>
								</RedesignLink>
							</li>))}
					</ul>
				</div>)}

			<p className="w-full text-center text-xs text-muted-foreground">
				If you need help, please contact us at{' '}
				<a href={`mailto:${ourEmail}`} className="font-medium text-neon-cyan hover:underline">{ourEmail}</a>
			</p>

			<Button variant="brand" onClick={modal.hide} className="w-full max-w-xs rounded-lg text-sm font-semibold">
				Got it
			</Button>
		</RedesignModalShell>);
});
